import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, resolveDirective as _resolveDirective } from "vue";
const _hoisted_1 = {
  id: "app-sidebar-1",
  class: "bg-surface-0 h-screen hidden lg:block flex-shrink-0 absolute lg:static left-0 top-0 z-[1000] border-r border-surface-200 select-none w-[280px]"
};
const _hoisted_2 = {
  class: "flex flex-col h-full"
};
const _hoisted_3 = {
  class: "flex items-center gap-4 p-3 pb-2 h-[4rem]"
};
const _hoisted_4 = {
  class: "w-9 h-9 flex items-center justify-center border border-surface-200 rounded-lg p-1"
};
const _hoisted_5 = ["src"];
const _hoisted_6 = {
  class: "flex flex-col gap-0.25 text-sm"
};
const _hoisted_7 = {
  class: "text-xs"
};
const _hoisted_8 = {
  class: "overflow-y-auto overflow-x-hidden flex-1 p-2 flex flex-col"
};
const _hoisted_9 = {
  class: "list-none m-0 flex flex-col gap-1"
};
const _hoisted_10 = ["onClick"];
const _hoisted_11 = {
  class: "flex items-center gap-3 w-full"
};
const _hoisted_12 = {
  class: "flex items-center justify-between gap-1 w-full"
};
const _hoisted_13 = {
  key: 0,
  class: "ml-auto inline-block bg-surface-400 rounded-xl font-semibold leading-none text-xs py-0.5 text-surface-0 dark:text-surface-900 h-fit w-fit px-2"
};
const _hoisted_14 = {
  key: 0,
  class: "ml-auto inline-block bg-primary rounded-xl font-semibold px-2 leading-none text-xs py-0.5 text-surface-0 h-fit w-fit"
};
const _hoisted_15 = {
  class: "mt-auto relative inline-block z-[200]"
};
const _hoisted_16 = {
  class: "bg-surface-0 border-surface-200 border rounded-lg hidden origin-bottom animate-duration-150 absolute left-full bottom-2 ml-2"
};
const _hoisted_17 = {
  class: "list-none p-2 m-0"
};
const _hoisted_18 = {
  key: 0
};
const _hoisted_19 = {
  class: "font-medium text-sm leading-tight"
};
const _hoisted_20 = {
  class: "font-medium text-sm leading-tight"
};
const _hoisted_21 = {
  class: "font-medium text-sm leading-tight"
};
const _hoisted_22 = {
  class: "flex items-center cursor-pointer p-3.5 gap-2 text-surface-900 hover: transition-colors duration-150 border-t border-surface-200"
};
const _hoisted_23 = ["src"];
const _hoisted_24 = {
  class: "font-medium text-sm leading-tight"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link");
  const _directive_styleclass = _resolveDirective("styleclass");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_router_link, {
    custom: "",
    to: "/"
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_createElementVNode("img", {
      src: $options.logo,
      alt: "logo",
      class: "cursor-pointer"
    }, null, 8, _hoisted_5)])]),
    _: 1
  }), _createElementVNode("div", _hoisted_6, [_cache[1] || (_cache[1] = _createElementVNode("div", {
    class: "font-bold"
  }, "Forecastify", -1)), _createElementVNode("div", _hoisted_7, _toDisplayString($options.tenantBadge), 1)])]), _createElementVNode("div", _hoisted_8, [_createElementVNode("ul", _hoisted_9, [_createElementVNode("li", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.menuItems, menuItem => {
    return _openBlock(), _createElementBlock(_Fragment, {
      key: menuItem.key
    }, [menuItem.link && menuItem.visible ? (_openBlock(), _createBlock(_component_router_link, {
      key: 0,
      to: menuItem.link,
      class: "flex items-center cursor-pointer p-2 gap-4 rounded-lg text-surface-900 hover:bg-surface-50 border border-transparent hover:border-surface-100 transition-colors duration-150"
    }, {
      default: _withCtx(() => [_createElementVNode("i", {
        class: _normalizeClass(`${menuItem.icon} !text-sm !leading-none text-surface-500hover:text-surface-900 `)
      }, null, 2), _createElementVNode("span", {
        class: _normalizeClass(["font-medium text-sm leading-tight", {
          'text-primary-500': $options.openMenuKeys.has(menuItem.key)
        }])
      }, _toDisplayString(menuItem.label), 3)]),
      _: 2
    }, 1032, ["to"])) : menuItem.items && menuItem.visible ? (_openBlock(), _createElementBlock(_Fragment, {
      key: 1
    }, [_createElementVNode("div", {
      onClick: $event => $options.toggleMenu(menuItem.key),
      class: "flex items-center justify-between cursor-pointer p-2 gap-2 rounded-lg text-surface-900 hover:bg-surface-50 border border-transparent hover:border-surface-100 transition-colors duration-150"
    }, [_createElementVNode("div", _hoisted_11, [_createElementVNode("i", {
      class: _normalizeClass(`${menuItem.icon} !text-sm !leading-none text-surface-500 hover:text-surface-900 w-4`)
    }, null, 2), _createElementVNode("div", _hoisted_12, [_createElementVNode("span", {
      class: _normalizeClass(["font-medium text-sm leading-tight", {
        'text-primary-500': $options.openMenuKeys.has(menuItem.key)
      }])
    }, _toDisplayString(menuItem.label), 3), menuItem.key === 'dashboard' ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_ctx.$tf("sidebar.dashboard.soon|hamarosan")), 1)) : _createCommentVNode("", true)])]), menuItem.items.length > 0 ? (_openBlock(), _createElementBlock("i", {
      key: 0,
      class: _normalizeClass(["fa-regular fa-chevron-right !text-xs !leading-none text-surface-500 ml-auto transition-transform", {
        '-rotate-90': $data.openedMenus.includes(menuItem.key)
      }])
    }, null, 2)) : _createCommentVNode("", true)], 8, _hoisted_10), _createElementVNode("ul", {
      class: _normalizeClass([[$data.openedMenus.includes(menuItem.key) ? 'max-h-full' : 'max-h-0'], "ml-4 pl-0 translate-x-[-1px] border-l border-surface-200 list-none m-0 overflow-hidden flex flex-col transition-[max-height] duration-500 ease-in-out"])
    }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuItem.items, menuSubItem => {
      return _withDirectives((_openBlock(), _createElementBlock("li", {
        key: menuSubItem.key
      }, [_createVNode(_component_router_link, {
        to: menuSubItem.link,
        class: "flex items-center cursor-pointer p-2 gap-2 rounded-lg text-surface-900 hover:bg-surface-50 border border-transparent hover:border-surface-100 transition-colors duration-150 hover:text-surface-900"
      }, {
        default: _withCtx(() => [_createElementVNode("i", {
          class: _normalizeClass(`${menuSubItem.icon} !text-sm !leading-none text-surface-500 hover:text-surface-900`)
        }, null, 2), _createElementVNode("span", {
          class: _normalizeClass(["font-medium text-sm leading-tight", {
            'text-primary-500': $options.openMenuKeys.has(menuSubItem.key)
          }])
        }, _toDisplayString(menuSubItem.label), 3), menuSubItem.key === 'time.requests' ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString($options.pendingRequestsCount), 1)) : _createCommentVNode("", true)]),
        _: 2
      }, 1032, ["to"])])), [[_vShow, menuSubItem.visible]]);
    }), 128))], 2)], 64)) : _createCommentVNode("", true)], 64);
  }), 128))])])]), _createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_createElementVNode("ul", _hoisted_17, [$options.canSeeSettings ? (_openBlock(), _createElementBlock("li", _hoisted_18, [_createVNode(_component_router_link, {
    to: "/settings",
    class: "flex items-center cursor-pointer p-2 gap-2 rounded-lg text-surface-700 hover:bg-surface-50 border border-transparent hover:border-surface-200 transition-colors duration-150 hover:text-surface-900 w-max"
  }, {
    default: _withCtx(() => [_cache[2] || (_cache[2] = _createElementVNode("i", {
      class: "fa-regular fa-gear !text-sm !leading-none"
    }, null, -1)), _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.$tf("sidebar.settings.menu|Beállítások")), 1)]),
    _: 1
  })])) : _createCommentVNode("", true), _createElementVNode("li", null, [_createVNode(_component_router_link, {
    to: "/profile#general",
    class: "flex items-center cursor-pointer p-2 gap-2 rounded-lg text-surface-700 hover:bg-surface-50 border border-transparent hover:border-surface-200 transition-colors duration-150 hover:text-surface-900 w-max"
  }, {
    default: _withCtx(() => [_cache[3] || (_cache[3] = _createElementVNode("i", {
      class: "fa-regular fa-user !text-sm !leading-none"
    }, null, -1)), _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.$tf("sidebar.profile|Profil")), 1)]),
    _: 1
  })]), _createElementVNode("li", null, [_createElementVNode("a", {
    onClick: _cache[0] || (_cache[0] = $event => $options.logout()),
    class: "flex items-center cursor-pointer p-2 gap-2 rounded-lg text-surface-700 hover:bg-surface-50 border border-transparent hover:border-surface-200 transition-colors duration-150 hover:text-surface-900 w-max"
  }, [_cache[4] || (_cache[4] = _createElementVNode("i", {
    class: "fa-regular fa-sign-out !text-sm !leading-none"
  }, null, -1)), _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.$tf("sidebar.logout|Kilépés")), 1)])])])]), _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_22, [_createElementVNode("img", {
    src: _ctx.avatar,
    alt: "Avatar",
    class: "w-8 h-8 rounded-full"
  }, null, 8, _hoisted_23), _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.displayName), 1), _cache[5] || (_cache[5] = _createElementVNode("i", {
    class: "fa-regular fa-angles-up-down !text-sm !leading-none text-surface-500 ml-auto"
  }, null, -1))])), [[_directive_styleclass, {
    selector: '@prev',
    enterFromClass: 'hidden',
    enterActiveClass: 'animate-scalein',
    leaveToClass: 'hidden',
    leaveActiveClass: 'animate-fadeout',
    hideOnOutsideClick: true
  }]])])])]);
}